import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class MessageService {
  constructor(private toast: ToastrService) {}

  error(error: any): void {
    let errorMessage: string = 'Dogodila se greška';

    if (error && error.error && error.error.errorCode) {
      switch (error.error.errorCode) {
        case 2:
          errorMessage = 'Proverite unete podatke';
          break;
        case 3:
          errorMessage = 'Ova akcija vam nije dozovljena';
          break;
        case 5:
          errorMessage = 'Nemate privelegije';
          break;
        case 6:
          errorMessage = 'Proverite unete podatke';
          break;
        case 8:
          errorMessage = 'Proverite email i lozinku';
          break;
        case 9:
          errorMessage = 'Unesite validnu email adresu';
          break;
        case 11:
          errorMessage = 'Dogodila se greška prilikom dodavanja fajla';
          break;
        case 12:
          errorMessage = 'Proverite email i lozinku';
          break;
        case 14:
          errorMessage = 'Mašina je preopterećena';
          break;
        case 15:
          errorMessage = 'Nemate dovoljno zaposlenih';
          break;
        case 16:
          errorMessage = 'Proverite format fajla';
          break;
        case 17:
          errorMessage = 'Niste uneli broj radnika';
          break;
        case 18:
          errorMessage = 'Niste uneli operacije';
          break;
        case 19:
          errorMessage = 'Materijali i/ili operacije nisu potvrđeni';
          break;
        case 20:
          errorMessage = 'Drugi proizvod je već unet';
          break;
        case 21:
          errorMessage = 'Niste popunili sastavnicu artikla';
          break;
        case 22:
          errorMessage = 'Operacija koju ste uneli već postoji u listi operacija';
          break;
        case 23:
          errorMessage = 'Niste izabrali primaoca mejla';
          break;
        case 25:
          errorMessage = 'Mašina ne pripada izabranom sektoru';
          break;
        case 27:
          errorMessage = 'Izabrani korisnik je na listi primalaca mejla. Molim Vas da ga prvo sklonite sa te liste';
          break;
        case 28:
          errorMessage = 'Niste uneli vreme za mašinu';
          break;
        case 29:
          errorMessage = 'Nije moguće izmeniti mernu jedinicu za artikal koji ima zalihe';
          break;
        case 32:
          errorMessage = 'Nema dovoljno količine na stanju za izabrani artikal';
          break;
        case 33:
          errorMessage = 'Magacin nije prazan. Prvo ispraznite zalihe, pa obrišite magacin';
          break;
        case 34:
          errorMessage = 'Artikal ima stanje na lageru. Ispraznite zalihe pre uklanjanja';
          break;
        case 35:
          errorMessage = 'Artikal postoji na zalihama u sistemu. Prebacite ih pre brisanja iz šifarnika';
          break;
        default:
          errorMessage = 'Dogodila se greška';
      }
    }

    error.error?.type === 'warning' ? this.toast.warning(errorMessage) : this.toast.error(errorMessage);
  }

  warning(message: string): void {
    this.toast.warning(message);
  }

  success(message: string): void {
    this.toast.success(message);
  }
}
